var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faStop } from "@fortawesome/pro-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { Button, Control, ControlGroup, TextField, ErrorList, Fields, DropdownField, DropDownItem, StyleField, } from "../Form";
import { AbsoluteOverlay } from "../Indicators";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDefaultValueListener } from "../../hooks";
import { camelCase } from "lodash";
import { partitions } from "./EventForm";
var schema = yup.object({
    name: yup.string().required("event name cannot be blank"),
    categoryUuid: yup.string(),
    styleUuid: yup.string().required("style cannot be blank"),
});
var compareAsString = function (a, b) {
    return "" + a === "" + b;
};
export var CategoryForm = function (_a) {
    var _b, _c;
    var externalSubmitHandler = _a.onSubmit, loading = _a.loading, _d = _a.categories, categories = _d === void 0 ? [] : _d, defaultValues = _a.defaultValues, submitTitle = _a.submitTitle, _e = _a.styles, styles = _e === void 0 ? [] : _e, handleEditTheme = _a.onEditTheme, handleEditStyle = _a.onEditStyle;
    var _f = useForm({
        resolver: yupResolver(schema),
        mode: "onBlur",
    }), handleSubmit = _f.handleSubmit, register = _f.register, formErrors = _f.formState.errors, watch = _f.watch, setError = _f.setError, setValue = _f.setValue, reset = _f.reset, control = _f.control;
    var _g = useState(false), advancedMode = _g[0], setAdvancedMode = _g[1];
    useDefaultValueListener(defaultValues, reset);
    var _h = watch([
        "categoryUuid",
        "partition",
        "interruptedByWeekends",
        "interruptedByHolidays",
        "styleUuid",
    ]), categoryUuid = _h[0], partition = _h[1], interruptedByWeekends = _h[2], interruptedByHolidays = _h[3], styleUuid = _h[4];
    var categoryStyles = categories.map(function (c) {
        return (__assign(__assign({}, styles.find(function (_a) {
            var uuid = _a.uuid;
            return uuid === c.styleUuid;
        })), { uuid: c.uuid, name: c.name }));
    });
    var handleFormSubmit = handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, errors, keys;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, externalSubmitHandler(data)];
                case 1:
                    _a = ((_b = (_c.sent())) !== null && _b !== void 0 ? _b : {}).errors, errors = _a === void 0 ? {} : _a;
                    keys = Object.keys(errors);
                    if (keys.length) {
                        keys.map(function (key) {
                            return setError(camelCase(key), {
                                message: errors[key],
                            });
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); });
    var field = useRef(null);
    useEffect(function () {
        var _a;
        (_a = field.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    var toggleAdvancedMode = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setAdvancedMode(true);
    };
    var handleStyleSelect = function (newVal) {
        setValue("styleUuid", newVal !== null && newVal !== void 0 ? newVal : "");
    };
    var handleCategorySelect = function (newVal) {
        setValue("categoryUuid", newVal !== null && newVal !== void 0 ? newVal : "");
    };
    var handleEditThemeClick = handleEditTheme
        ? function (e) {
            e.preventDefault();
            e.stopPropagation();
            handleEditTheme === null || handleEditTheme === void 0 ? void 0 : handleEditTheme();
        }
        : null;
    var handleEditStyleClick = handleEditStyle
        ? function (e) {
            e.preventDefault();
            e.stopPropagation();
            handleEditStyle(styleUuid);
        }
        : null;
    return (_jsxs("form", __assign({ onSubmit: handleFormSubmit, className: "relative" }, { children: [_jsxs(Fields, __assign({ register: register, errors: formErrors, grow: true, className: "pb-2" }, { children: [_jsx(TextField, { name: "name", label: "Name", placeholder: "Name of Category", required: true, ref: field, className: "w-full" }, void 0), _jsx(StyleField, { name: "styleUuid", options: styles, value: styleUuid, label: "Style", id: "styleUuid", placeholder: "choose a style", className: "flex-grow flex-shrink-0 w-full", onSelect: handleStyleSelect, required: true, selfControllable: true }, void 0), _jsx("input", { type: "hidden", name: "styleUuid" }, void 0), _jsxs("div", __assign({ className: "flex" }, { children: [handleEditStyleClick ? (_jsx(Button, __assign({ type: "button", appearance: "link", className: "-mt-2 text-xs", onClick: handleEditStyleClick }, { children: "Edit Style" }), void 0)) : null, handleEditThemeClick ? (_jsx(Button, __assign({ type: "button", appearance: "link", className: "-mt-2 ml-2 text-xs", onClick: handleEditThemeClick }, { children: "Manage Theme" }), void 0)) : null] }), void 0), _jsxs(Fields, __assign({ className: advancedMode ? "visible" : "hidden", nested: true, grow: true, strictVertical: true }, { children: [_jsx(StyleField, { name: "categoryUuid", options: categoryStyles, value: categoryUuid, label: "Parent Category", id: "categoryUuid", placeholder: "Select a category (optional)", className: "flex-grow flex-shrink-0 w-full", onSelect: handleCategorySelect, clearable: true, selfControllable: true }, void 0), _jsx("input", { type: "hidden", name: "categoryUuid" }, void 0), _jsx(DropdownField, __assign({ name: "partition", label: "Default Day Part", placeholder: "Select a Daypart", value: (_c = (_b = partitions.find(function (p) { return compareAsString(p.value, partition !== null && partition !== void 0 ? partition : 0); })) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "", grow: true, hideSearch: true }, { children: function (search) {
                                    return partitions
                                        .filter(function (o) {
                                        return search.length === 0 ||
                                            o.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
                                    })
                                        .map(function (o) { return (_jsx(DropDownItem, __assign({ onClick: function (e) {
                                            e.preventDefault();
                                            setValue("partition", o.value);
                                        }, selected: "" + partition === "" + o.value, item: { label: o.name, id: "" + o.value } }, { children: o.name }), o.value)); });
                                } }), void 0), _jsxs(Fields, __assign({ nested: true }, { children: [_jsxs(ControlGroup, __assign({ name: "interruptedByWeekends", label: "Run on Weekends", selected: interruptedByWeekends !== null && interruptedByWeekends !== void 0 ? interruptedByWeekends : "0" }, { children: [_jsx(Control, __assign({ value: "0" }, { children: _jsx(FontAwesomeIcon, { icon: faPlay }, void 0) }), void 0), _jsx(Control, __assign({ value: "1" }, { children: _jsx(FontAwesomeIcon, { icon: faStop }, void 0) }), void 0)] }), void 0), _jsxs(ControlGroup, __assign({ name: "interruptedByHolidays", label: "Run on Holidays", selected: interruptedByHolidays !== null && interruptedByHolidays !== void 0 ? interruptedByHolidays : "0" }, { children: [_jsx(Control, __assign({ value: "0" }, { children: _jsx(FontAwesomeIcon, { icon: faPlay }, void 0) }), void 0), _jsx(Control, __assign({ value: "1" }, { children: _jsx(FontAwesomeIcon, { icon: faStop }, void 0) }), void 0)] }), void 0)] }), void 0)] }), void 0), advancedMode ? (_jsx("span", {}, void 0)) : (_jsx(Button, __assign({ onClick: toggleAdvancedMode, appearance: "link", className: "-my-4" }, { children: "Additional Details" }), void 0)), _jsx(ErrorList, { errors: formErrors }, void 0), _jsx(Button, __assign({ type: "submit", className: "mt-2 w-full" }, { children: submitTitle !== null && submitTitle !== void 0 ? submitTitle : "Save Category" }), void 0)] }), void 0), loading ? _jsx(AbsoluteOverlay, {}, void 0) : null] }), void 0));
};
